export default {
  showThumbnails: 'Zobraziť náhľady',
  close: 'Zatvoriť galériu',
  zoomIn: 'Zväčšiť',
  source: 'Zdroj',
}
